// extracted by mini-css-extract-plugin
export default {"btnPrev":"Slider_btnPrev__jSJqW","btnNext":"Slider_btnNext__RHYtD","carSlider":"Slider_carSlider__RGen7"};